module.exports = __webpack_public_path__ + "img/onboarding-bg.ed3de432.svg";